import './ModalIndexCard.scss'
import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { Row, Col, Input, Modal, Button, Icon, Select, message, List, Radio, Upload } from 'antd'
import { ModalPdfViewer } from '../../../../../InterestConflicts/components'
import { useTranslation } from 'react-i18next'
import { getFormPromise, saveStatePromise, saveCommentsPromise } from '../../promises'
import { HistoryModal } from '../../../../../../layouts/Private/components'
import { ReportService } from '../../../../../../services'

const ModalIndexCard = ({item, handleCancel}) => {

  const [seeMore1, setSeemore1] = useState(false);
  const [seeMore2, setSeemore2] = useState(false);
  const [seeMore3, setSeemore3] = useState(false);
  const [seeMore4, setSeemore4] = useState(false);
  const [itemTable, setItemTable] = useState(item);
  const [formId, setFormId] = useState(null);
  const { t } = useTranslation();
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [statusComments, setStatusComments] = useState(null);
  const [comments, setComments] = useState("");
  const [title, setTitle] = useState(null);
  const [isHistoryVisible, setIsHistoryVisible] = useState(false);
  const [lastCommentDate, setLastCommentDate] = useState(null);
  const [ resendOnBoardingForm, setResendOnBoardingForm ] = useState(false);
  const [ showAttachments, setShowAttachments] = useState(null);
  const [ userFileName, setUserFileName] = useState("");
  const [ fileNames, setFileNames] = useState([]);
  const [ tmpFilesList, setTmpFilesList] = useState([]);
  const [ loadingAttch ,setLoadingAttch ] = useState(false)

  useEffect(() => {
    getFormPromise(item.id).then((response) => {
      setItemTable(response.data);
        if(response.data.histComments.length > 0){
          setLastCommentDate(moment(response.data.histComments[0].creationDate).format('DD/MM/YYYY HH:mm'));
        }
    })
  }, []);


  const handleMore1 = () => {
    if (seeMore1 === false){
      setSeemore1(true)
    }else
      setSeemore1(false)
  }

  const handleMore2 = () => {
    if (seeMore2 === false){
      setSeemore2(true)
    }else
      setSeemore2(false)
  }

  const handleMore3 = () => {
    if (seeMore3 === false){
      setSeemore3(true)
    }else
      setSeemore3(false)
  }

  const handleMore4 = () => {
    if (seeMore4 === false){
      setSeemore4(true)
    }else
      setSeemore4(false)
  }

  const statusLabel = (val) => t(`messages.aml.formKycStatus.${val}`)
  const varStateOptions = (actualState) => {
    var options = [];
    if (actualState === 'EVALUACION'){
      options.push({val: "AUTORIZADA", label: statusLabel("AUTORIZADA")}, {val: "RECHAZADA", label: statusLabel("RECHAZADA")}, {val: "OBSERVADA", label: statusLabel("OBSERVADA")});
    }else if (actualState === 'AUTORIZADA'){
      options.push({val: "EVALUACION", label: statusLabel("EVALUACION")}, {val: "RECHAZADA", label: statusLabel("RECHAZADA")}, {val: "OBSERVADA", label: statusLabel("OBSERVADA")});
    }else if(actualState === 'RECHAZADA'){
        options.push({val: "EVALUACION", label: statusLabel("EVALUACION")}, {val: "AUTORIZADA", label: statusLabel("AUTORIZADA")}, {val: "OBSERVADA", label: statusLabel("OBSERVADA")});
    }else if (actualState === 'OBSERVADA'){
      options.push({val: "EVALUACION", label: statusLabel("EVALUACION")}, {val: "AUTORIZADA", label: statusLabel("AUTORIZADA")}, {val: "RECHAZADA", label: statusLabel("RECHAZADA")});
    }
    return options;
  }

  const handleListDeleted= (index) =>{
    setFileNames(oldFileNames => {
      const newFileNames = oldFileNames.slice();
      newFileNames.splice(index, 1)

      return newFileNames
    })

    setTmpFilesList(oldTmpFilesList => {
      const newTmpFilesList = oldTmpFilesList.slice();
      newTmpFilesList.splice(index, 1)

      return newTmpFilesList
    })
  }

  const propsUpload = {
    accept: ".pdf, .png, .docx, .xlsx",
    onRemove: file => {
      const index = tmpFilesList.indexOf(file);
      handleListDeleted(index);
    },
    beforeUpload: file => {
      const validFiles = file.type === 'application/pdf' || file.type === 'image/png'|| file.name.endsWith('.docx') || file.name.endsWith('.xlsx');
      if (!validFiles) {
        message.error(t('messages.aml.onboarding.modalIndexCard.formatNotAllowed'));
      }else{
        const validSize = file.size / 1024 / 1024 < 2;
        if (!validSize) {
          message.error(t('messages.aml.onboarding.modalIndexCard.maxFileSize'));
        }else{
          if(userFileName === "" || userFileName === null){
            message.error(t('messages.aml.onboarding.modalIndexCard.mustEnterDocumentName'))
          }else{
            setTmpFilesList(oldTmpFilesList => [...oldTmpFilesList, file]);
            setFileNames(oldFileNames => [...oldFileNames, userFileName]);
          }
        }
        setUserFileName(null)
      }
      return false
    },
    multiple: false,
    showUploadList: false
  }

  const handlePdfViewer = (record) => {
    setFormId(record.id);
  }

  const onCancelPdfViewer = () => {
    setFormId(null);
  }

  const handleSaveStatus = () => {
      saveStatePromise(item.id, selectedStatus, statusComments, resendOnBoardingForm).then((response) => {
        if(response.success === true){
          message.success(t('messages.aml.onboarding.modalIndexCard.stateSaveSuccess'));
          handleCancel();
        }else{
        message.error(t('messages.aml.onboarding.modalIndexCard.stateSaveError'))
        }
      })
  }

  const handleSaveAttachment = () => {
    const formData = new FormData()
    formData.append( 'formId', item.id)
    formData.append('title', title)
    formData.append('comments', comments)

    if(tmpFilesList !== null){
      tmpFilesList.forEach((file, index) => {
        formData.append('file', file)
        formData.append('fileName', fileNames[index])
      })
      if (tmpFilesList.length <= 10){
          setLoadingAttch(true)
          saveCommentsPromise(formData).then((response) => {
          if(response.success === true){
            message.success(t('messages.aml.onboarding.modalIndexCard.commentSaveSuccess'))
            setItemTable(response.data)
            setLastCommentDate(moment(response.data.histComments[0].creationDate).format('DD/MM/YYYY HH:mm'));
            setComments(null);
            setTitle(null);
            setTmpFilesList([]);
            setShowAttachments(null)
            setLoadingAttch(false)
            setFileNames(null)
          }else{
            message.error(t('messages.aml.onboarding.modalIndexCard.commentSaveError'))
            setLoadingAttch(false)
          }
        })
      }else{
        message.error(t('messages.aml.onboarding.modalIndexCard.maxTenDocuments'))
      }
    }
  }

  const handleOnChangeStatus = (value) => {
    setSelectedStatus(value);
  }

  const handleCommentsStateChange = (comment) => {
    setStatusComments(comment);
  }

  const handleTitle = (title) => {
    setTitle(title);
  }

  const handleComments = (comment) => {
    setComments(comment);
  }

  const handleSaveComment = () => {

    if(title){
    setShowAttachments({id: item.id, title, comments})
    }else{
      message.error(t('messages.aml.onboarding.modalIndexCard.mustEnterTitle'))
    }
  }

  const handleGetFile = async (originalName) => {
    const obj = {
      formId: item.id,
      fileName: originalName,
    }
    await ReportService.read('/getFileForm', obj, null, originalName)
  }

  const handleCloseModals = () => {
    setIsHistoryVisible(false);
  }

  const commentSchema = [
    {
      title: t('messages.aml.onboarding.modalIndexCard.schemaDate'),
      dataIndex: 'creationDate',
      cols: 4
    },
    {
      title: t('messages.aml.onboarding.modalIndexCard.schemaName'),
      dataIndex: 'userName',
      cols: 8
    },
    {
      title: t('messages.aml.onboarding.modalIndexCard.schemaTitle'),
      dataIndex: 'title',
      cols: 12
    },
  ];

    return (
      <div className="modIndexCard">
        <Row className="titleRow" onClick={handleMore1}>
          <Col span={6}>
            <h3>{t('messages.aml.onboarding.modalIndexCard.basicInfoTitle')}</h3>
          </Col>
          <Col span={4} push={16}>
            <Button type="link" onClick={handleMore1}>{t('messages.aml.onboarding.modalIndexCard.viewMore')}<Icon type={seeMore1 ? "minus" : "plus"}/></Button>
          </Col>
        </Row>
        <hr/>
        <Row>
          <Col span={6} >
            {t('messages.aml.onboarding.modalIndexCard.nameOrLegal')}
            <Input readOnly value={itemTable.json && itemTable.json.basicInformation && itemTable.json.basicInformation.basicInfo ? itemTable.json.basicInformation.basicInfo.name : item.name}/>
          </Col>
          <Col span={5} offset={1}>
            {t('messages.aml.onboarding.modalIndexCard.documentType')}
            <Input readOnly value={itemTable.json && itemTable.json.basicInformation && itemTable.json.basicInformation.basicInfo ? itemTable.json.basicInformation.basicInfo.tipoDocumento:"-"}/>
          </Col>
          <Col span={5} offset={1}>
            {t('messages.aml.onboarding.modalIndexCard.documentNumber')}
            <Input readOnly value={itemTable.json && itemTable.json.basicInformation && itemTable.json.basicInformation.basicInfo ? itemTable.json.basicInformation.basicInfo.nroDocumento : item.rut} />
          </Col>
          <Col span={5} offset={1}>
            {t('messages.aml.onboarding.modalIndexCard.personType')}
            <Input readOnly value={itemTable.recipient && itemTable.recipient.record.type === 'Person' ? t('messages.aml.onboarding.modalIndexCard.naturalPerson') : t('messages.aml.onboarding.modalIndexCard.legalPerson')} />
          </Col>
        </Row>
        {seeMore1 &&
          <Row className="div-more-info">
            <Col span={7} >
              {t('messages.aml.onboarding.modalIndexCard.company')}
              <Input readOnly value={itemTable.recipient.record.subcliente ? itemTable.recipient.record.subcliente.name : t('messages.aml.onboarding.modalIndexCard.noCompanyAssigned')}/>
            </Col>
            <Col span={7} offset={1}>
              {t('messages.aml.onboarding.modalIndexCard.area')}
              <Input readOnly value={itemTable.recipient.record.area}/>
            </Col>
            <Col span={7} offset={1}>
              {t('messages.aml.onboarding.modalIndexCard.group')}
              <Input readOnly value={itemTable.recipient.record.grupo ? itemTable.recipient.record.grupo : t('messages.aml.onboarding.modalIndexCard.noGroupAssigned')}/>
            </Col>
          </Row>
        }
        {/* FIN INFORMACION BASICA */}
          <Row>
            <Col span={9}>
              <h3>{t('messages.aml.onboarding.modalIndexCard.sectionOnboardingFormTitle')}</h3>
            </Col>
            {item.statusDecl !== 'PENDIENTE' &&
            <>
              <Col span={15}>
                <div className="button-box-index">
                  <Button type="primary" onClick={() => handlePdfViewer(item)}>{t('messages.aml.onboarding.modalIndexCard.viewForm')}<Icon type="file-pdf" /></Button>
                </div>
              </Col>
            </>
            }
              {formId &&
                <Modal
                className="modal-pdf-viewer"
                title={t('messages.aml.onboarding.modalIndexCard.modalFormTitle')}
                centered
                width={1000}
                header={null}
                footer={[<Button key="back" onClick={onCancelPdfViewer}>{t('messages.aml.onboarding.modalIndexCard.close')}</Button>]}
                onCancel={onCancelPdfViewer}
                visible="true"
                ><ModalPdfViewer
                  pdfId={formId}
                />
                </Modal>
              }
          </Row>
          <hr/>
          <Row>
            <Col span={6} >
              {t('messages.aml.onboarding.modalIndexCard.state')}
              <Input readOnly value={t("messages.aml.formKycStatus."+item.statusDecl)}/>
            </Col>
            <Col span={5} offset={1}>
              {t('messages.aml.onboarding.modalIndexCard.requestDate')}
              <Input readOnly value={moment(item.fecSolicitud).format('DD/MM/YYYY')}/>
            </Col>
            <Col span={5} offset={1}>
              {t('messages.aml.onboarding.modalIndexCard.remindersCount')}
              <Input readOnly value={item.nroReminders && item.nroReminders > 0 ? item.nroReminders : t('messages.aml.onboarding.modalIndexCard.noReminders')}/>
            </Col>
            <Col span={5} offset={1}>
              {t('messages.aml.onboarding.modalIndexCard.lastReminderDate')}
              <Input readOnly value={item.lastReminder !== null ? moment(item.lastReminder).format('DD/MM/YYYY') : '-'} />
            </Col>
          </Row>
          {item.statusDecl !== 'PENDIENTE' &&
            <Row>
              <Col span={6} >
                {t('messages.aml.onboarding.modalIndexCard.attachments')}
                <Input readOnly value={itemTable.files && itemTable.files.length > 0 ? itemTable.files.length : t('messages.aml.onboarding.modalIndexCard.noAttachments')}/>
              </Col>
              <Col span={5} offset={1}>
                {t('messages.aml.onboarding.modalIndexCard.receptionDate')}
                <Input readOnly value={moment(item.receiveDate).format('DD/MM/YYYY')}/>
              </Col>
              {item?.statusDecl === 'AUTORIZADA' && item?.statusDate &&
                <Col span={5} offset={1}>
                  {t('messages.aml.onboarding.modalIndexCard.authDate')}
                  <Input readOnly value={moment(item.statusDate).format('DD/MM/YYYY')}/>
                </Col>
              }
              {item?.statusDecl === 'RECHAZADA' &&
                <Col span={5} offset={1}>
                  {t('messages.aml.onboarding.modalIndexCard.rejectDate')}
                  <Input readOnly value={item?.statusDate ? moment(item.statusDate).format('DD/MM/YYYY') : '---'}/>
                </Col>
              }
              {item?.statusDecl === 'OBSERVADA' &&
                <Col span={5} offset={1}>
                  {t('messages.aml.onboarding.modalIndexCard.observationDate')}
                  <Input readOnly value={item?.statusDate ? moment(item.statusDate).format('DD/MM/YYYY') : '---'}/>
                </Col>
              }
            </Row>
          }

          {/* FIN INFORMACION SOLICITUD REALIZADA */}
          <Row onClick={handleMore2}>
            <Col span={6}>
              <h3>{t('messages.aml.onboarding.modalIndexCard.comments')}</h3>
            </Col>
            <Col span={4} push={16}>
              <Button type="link" onClick={handleMore2}>{t('messages.aml.onboarding.modalIndexCard.viewMore')} <Icon type={seeMore2 ? "minus" : "plus"}/></Button>
            </Col>
          </Row>
          <hr/>
          {seeMore2 &&
            <div className="div-more-info">
              <Row>
                <Col span={5} >
                  {t('messages.aml.onboarding.modalIndexCard.title')}
                  <Input onChange={(e) => {handleTitle(e.target.value)}} value={title}/>
                </Col>
                <Col span={18} push={1}>
                  {t('messages.aml.onboarding.modalIndexCard.comment')}
                  <Input.TextArea onChange={(e) => {handleComments(e.target.value)}} value={comments}/>
                </Col>
              </Row>
              <Col span={6}>
                {lastCommentDate &&
                  <Button onClick={() => setIsHistoryVisible(true)} style={{padding:'unset'}}type="link">{t('messages.aml.onboarding.modalIndexCard.viewPreviousComments')}</Button>
                }
              </Col>
              <Col span={6}>
                <div>
                  {t('messages.aml.onboarding.modalIndexCard.lastComment')}: {lastCommentDate ? lastCommentDate : t('messages.aml.onboarding.modalIndexCard.noComments')}
                </div>
              </Col>
              <Col span={12}>
                <Button onClick={() => handleSaveComment()} style={{float:'right', padding:'unset'}}type="link">{t('messages.aml.onboarding.modalIndexCard.save')}</Button>
              </Col>
              <Row>
              </Row>
            </div>
          }
          { showAttachments &&
            <Modal
              title={t('messages.aml.onboarding.modalIndexCard.attachDocumentsTitle')}
              centered
              footer={[<Button key="back" onClick={() => setShowAttachments(null)}>{t('messages.aml.onboarding.modalIndexCard.close')}</Button>,
                <Button type="primary" key="save" loading={loadingAttch} onClick={() => handleSaveAttachment()}>{t('messages.aml.onboarding.modalIndexCard.save')}</Button>
              ]}
              onCancel={() => setShowAttachments(null)}
              visible={true}
              >
              <Row>
                {t('messages.aml.onboarding.modalIndexCard.attachDocumentsHint')}
              </Row>
              <Row style={{marginTop: 15}}>
                <Col span={16}>
                  <Input
                    placeholder={t('messages.aml.onboarding.modalIndexCard.documentNamePlaceholder')}
                    autoComplete="off"
                    onChange={(e) => setUserFileName(e.target.value) }
                    value={userFileName}
                  />
                </Col>
                <Col span={7} offset={1}>
                  <Upload {...propsUpload} >
                    <Button disabled={tmpFilesList.length > 9} >
                      <Icon type="upload" /> {t('messages.aml.onboarding.modalIndexCard.uploadFile')}
                    </Button>
                  </Upload>
                </Col>
              </Row>
              <Row>
                {tmpFilesList.length > 0 &&
                  <List
                    size="small"
                    header={t('messages.aml.onboarding.modalIndexCard.attachedDocumentsListHeader')}
                    itemLayout="horizontal"
                    dataSource={tmpFilesList.map((file, index)=> {return {fileName: file.name, docName: fileNames[index], index: index}})}
                    renderItem={item => (
                      <List.Item
                        actions={[<a onClick={() => handleListDeleted(item.index)}>{t('messages.aml.onboarding.modalIndexCard.delete')}</a>]}
                      >
                        <List.Item.Meta
                            description={item.docName}
                        />
                        <List.Item.Meta
                          description={item.fileName}
                        />
                      </List.Item>
                    )}
                  />
                }
              </Row>
            </Modal>
          }
          {isHistoryVisible &&
              <HistoryModal formId={item.id} flowType="attachment" schema={commentSchema} data={itemTable.histComments} closeHandler={handleCloseModals}/>
          }
          {/* FIN COMENTARIOS */}
          {item.statusDecl !== 'PENDIENTE' &&
          <>
            <Row onClick={handleMore3}>
              <Col span={10}>
                <h3>{t('messages.aml.onboarding.modalIndexCard.documentsInFormTitle')}</h3>
              </Col>
              <Col span={4} push={12}>
                <Button type="link" onClick={handleMore3}>{t('messages.aml.onboarding.modalIndexCard.viewMore')} <Icon type={seeMore3 ? "minus" : "plus"}/></Button>
              </Col>
            </Row>
            <hr/>
            {seeMore3 &&
              <Row className="div-more-info">
                <Col span={24} >
                <List
                  size="small"
                  itemLayout="horizontal"
                  dataSource={itemTable.files}
                  renderItem={item => (
                    <List.Item
                      actions={[<a onClick={() => handleGetFile(item.originalName)}>{t('messages.aml.download')}</a>]}
                    >
                        <List.Item.Meta
                          description={item.name}
                        />
                        <List.Item.Meta
                          description={item.originalName}
                        />
                    </List.Item>
                  )}
                />
                </Col>
              </Row>
            }
          </>
          }
          {/* FIN DOC ADJUNTOS */}
        { item.statusDecl !== 'PENDIENTE' &&
          <>
            <Row onClick={handleMore4}>
              <Col span={10}>
                <h3>{t('messages.aml.onboarding.modalIndexCard.modifyStateTitle')}</h3>
              </Col>
              <Col span={4} push={12}>
                <Button type="link" onClick={handleMore4}>{t('messages.aml.onboarding.modalIndexCard.viewMore')} <Icon type={seeMore4 ? "minus" : "plus"}/></Button>
              </Col>
            </Row>
            <hr/>
            {seeMore4 &&
              <div className="status-box div-more-info">
                <Row>
                  <Col span={6} >
                    <h3>{t('messages.aml.onboarding.modalIndexCard.stateChangeHeading')}</h3>
                  </Col>
                  <Col span={8} push={10}>
                    <Select
                      style={{width: '100%'}}
                      defaultValue={t("messages.aml.formKycStatus."+item.statusDecl)}
                      onChange={handleOnChangeStatus}
                      // disabled={item.statusDecl === "EVALUACION" ? false : true} (se activa disabled si se cambia el estado)
                      >
                        {varStateOptions(item.statusDecl).map(option =>
                            <Select.Option key={option.val} value={option.val}>{option.label}</Select.Option>
                          )
                        }
                    </Select>
                  </Col>
                </Row>
                  {selectedStatus &&
                  <Modal
                    title={t('messages.aml.onboarding.modalIndexCard.stateChangeHeading')}
                    centered
                    width={700}
                    visible="true"
                    onCancel={() => setSelectedStatus(null)}
                    footer={[
                      <Button key="save" onClick={() => handleSaveStatus()}>{t('messages.aml.onboarding.modalIndexCard.save')}</Button>
                    ]}
                    >
                      <Row>
                        <Col span={24}>
                          {t('messages.aml.onboarding.modalIndexCard.stateChangeIntroPrefix')} {t("messages.aml.formKycStatus."+selectedStatus)}. <br/>
                          {t('messages.aml.onboarding.modalIndexCard.stateChangeIntroLine2')}
                        </Col>
                      </Row>
                      <Row gutter={[0, 32]}>
                        <Col span={24}>
                          <Input.TextArea placeholder={t('messages.aml.onboarding.modalIndexCard.commentsPlaceholderState')} onChange={(e) => handleCommentsStateChange(e.target.value)} />
                        </Col>
                      </Row>
                      {selectedStatus === 'RECHAZADA' &&
                      <>
                        <Row gutter={[0, 32]}>
                          <Col span={20}>
                            {t('messages.aml.onboarding.modalIndexCard.resendQuestion')}
                          </Col>
                          <Col span={4}>
                            <Radio.Group defaultValue={false} buttonStyle="solid" onChange={(e) => setResendOnBoardingForm(e.target.value)}>
                              <Radio.Button value={true}>{t('messages.aml.onboarding.modalIndexCard.yes')}</Radio.Button>
                              <Radio.Button value={false}>{t('messages.aml.onboarding.modalIndexCard.no')}</Radio.Button>
                            </Radio.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={24}>
                            {t('messages.aml.onboarding.modalIndexCard.resendEmailNote')}
                          </Col>
                        </Row>
                      </>
                      }
                  </Modal>
                  }
              </div>
            }
          </>
        }
      </div>
    );
}
export default ModalIndexCard
